import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import ControlledDateInput from '@/components/common/form/ControlledDateInput';
import translate from '@/lib/intl/translate';

export default function ControlledStartEndDateInputs({
  classes,
  control,
  disabled,
  endDateLabel,
  endDateName,
  endDateRules,
  errors,
  id,
  required,
  size,
  startDateLabel,
  startDateName,
  startDateRules,
  trigger,
  watch,
}) {
  const watchStartDate = watch(startDateName);
  const watchEndDate = watch(endDateName);

  React.useEffect(() => {
    trigger([startDateName, endDateName]);
  }, [watchEndDate, watchStartDate]);

  return (
    <>
      <div className={classnames(classes.startInputContainer)}>
        <ControlledDateInput
          classes={{ root: classes.inputRoot }}
          control={control}
          disabled={disabled}
          disableToolbar
          id={`${id}-start-date`}
          label={startDateLabel}
          margin="none"
          name={startDateName}
          required={required}
          rules={startDateRules}
          size={size}
          value={watchStartDate}
          {...(!!errors?.[startDateName] && {
            error: !!errors?.[startDateName]?.message,
          })}
          {...(!!errors?.[startDateName]?.message && {
            helperText: errors?.[startDateName]?.message,
          })}
        />
      </div>

      <div className={classnames(classes.endInputContainer)}>
        <ControlledDateInput
          classes={{ root: classes.inputRoot }}
          control={control}
          disabled={disabled}
          disableToolbar
          id={`${id}-end-date`}
          label={endDateLabel}
          margin="none"
          name={endDateName}
          required={required}
          rules={endDateRules}
          size={size}
          value={watchEndDate}
          {...(watchStartDate && { minDate: watchStartDate })}
          {...(!!errors?.[endDateName] && {
            error: !!errors?.[endDateName]?.message,
          })}
          {...(!!errors?.[endDateName]?.message && {
            helperText: errors?.[endDateName]?.message,
          })}
        />
      </div>
    </>
  );
}

ControlledStartEndDateInputs.propTypes = {
  classes: PropTypes.shape({
    endInputContainer: PropTypes.string,
    inputRoot: PropTypes.string,
    startInputContainer: PropTypes.string,
  }),
  control: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  errors: PropTypes.object.isRequired,
  endDateLabel: PropTypes.string,
  endDateName: PropTypes.string,
  endDateRules: PropTypes.object,
  id: PropTypes.string.isRequired,
  required: PropTypes.bool,
  size: PropTypes.string,
  startDateLabel: PropTypes.string,
  startDateName: PropTypes.string,
  startDateRules: PropTypes.object,
  trigger: PropTypes.func.isRequired,
  watch: PropTypes.func.isRequired,
};

ControlledStartEndDateInputs.defaultProps = {
  classes: {},
  disabled: false,
  endDateLabel: translate('FORMS_END_DATE_LABEL'),
  endDateName: 'endDate',
  endDateRules: {},
  required: false,
  size: 'medium',
  startDateLabel: translate('FORMS_START_DATE_LABEL'),
  startDateName: 'startDate',
  startDateRules: {},
};
